/* eslint-disable sonarjs/no-duplicate-string */
import { ThemeConfig } from 'antd';

import tokens from './tokens';
import palette from '../default/palette';

const components = {
  Tag: {
    borderRadius: 4,
    colorBorder: palette.gray[4]
  },
  Drawer: {
    colorBgBase: palette.gray[11]
  },
  Radio: {
    colorPrimary: palette.brand.primary,
    colorBorder: palette.gray[8],
    colorBgContainer: 'rgba(0, 0, 0, 0.04)'
  },
  Select: {
    colorIcon: palette.alpha(palette.gray[0], 0.45),
    colorBorder: 'rgba(0, 0, 0, 0.04)',
    colorText: tokens?.colorText,
    colorBgContainer: 'rgba(0, 0, 0, 0.04)',
    colorTextBase: 'rgba(0, 0, 0, 0.04)',
    colorTextPlaceholder: 'rgba(0, 0, 0, 0.25)',
    fontSizeLG: 16
  },
  Button: {
    colorBorder: palette.gray[0],
    fontSize: 16,
    fontSizeLG: 16,
    fontWeightStrong: 500,
    colorTextLightSolid: palette.gray[0]
  },
  Dropdown: {
    colorBgElevated: palette.gray[2],
    colorText: palette.gray[12],
    fontSize: 16,
    fontSizeIcon: 16,
    colorBorder: palette.gray[12],
    colorBorderBg: palette.gray[12]
  },
  Divider: {
    colorSplit: palette.alpha(palette.gray[0], 0.45)
  },
  Typography: {
    colorLinkHover: palette.gray[11],
    colorLinkActive: palette.alpha(palette.gray[0], 0.25),
    colorLink: palette.gray[12]
  },
  Input: {
    colorText: tokens?.colorText,
    colorBgContainer: palette.gray[2],
    colorBorder: 'rgba(0, 0, 0, 0.04)',
    colorBgBase: 'rgba(0, 0, 0, 0.04)',
    colorTextPlaceholder: 'rgba(0, 0, 0, 0.25)',
    colorTextDisabled: 'rgba(0, 0, 0, 0.25)',
    fontSizeLG: 16
  },
  Tabs: {
    fontSizeTabActive: 20,
    fontSizeLG: 18,
    fontSizeSM: 16,
    colorText: palette.gray[12]
  },
  Result: {
    colorText: palette.gray[0]
  },
  Checkbox: {
    colorBorder: palette.gray[8],
    colorBgContainer: 'rgba(0, 0, 0, 0.04)'
  },
  Timeline: {
    colorSplit: palette.gray[8],
    lineWidthBold: 1
  },
  Modal: {
    colorBgBase: palette.gray[1],
    colorBgContainer: palette.gray[0],
    colorBgElevated: palette.gray[0]
  },
  Skeleton: {
    color: 'rgba(0, 0, 0, 0.04)'
  }
} as ThemeConfig['components'];

export default components;
